import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import ViPropTypes from '../propTypes';
import ReactGA from 'react-ga';
import DashboardFrameData from './DashboardFrameData';
import {SwipeableTabs, SwipeableTab} from '../Form/SwipeableTabs';
import GaugeDashboard from './mobile/GaugeDashboard';
import OerEventsDashboard from './mobile/OerEventsDashboard';

export default class MobileDashboard extends React.Component {

  static propTypes = {
    mediaLoaded: PropTypes.bool,
    showEventLabel: PropTypes.bool,
    withTabs: PropTypes.bool,
    currentFrame: PropTypes.instanceOf(DashboardFrameData),
    media: ViPropTypes.Media,
    customerSettings: ViPropTypes.CustomerSettings
  };

  static defaultProps = {
    mediaLoaded: true,
    showEventLabel: false,
    withTabs: true,
    currentFrame: new DashboardFrameData(),
    customerSettings: {
      gpsSpeed: false
    },
    userSettings: {
      settings: {
        systemMeasure: 'imperial'
      }
    }
  }

  trackSwipe = (nextIndex, currentIndex) => {
    if (nextIndex === currentIndex) {
      return;
    }

    ReactGA.event({
      category: 'Player',
      action: (nextIndex < currentIndex) ? 'Swipe Left' : 'Swipe Right',
      label: 'Driver Dashboard'
    });
  }

  renderGaugeDashboard() {
    const {
      mediaLoaded,
      currentFrame,
      customerSettings,
      userSettings
    } = this.props;

    return (
      <GaugeDashboard
        mediaLoaded={mediaLoaded}
        currentFrame={currentFrame}
        customerSettings={customerSettings}
        userSettings={userSettings}
      />
    );
  }

  renderOerEventsDashboard() {
    const {media, showEventLabel} = this.props;
    return (
      <OerEventsDashboard
        media={media}
        showEventLabel={showEventLabel}
      />
    );
  }

  renderWithTabs() {
    if (!this.props.withTabs) {
      return null;
    }

    return (
      <SwipeableTabs
        tabsPosition="bottom"
        className="smalldots"
        tabsProps={{
          indicatorColor: 'primary',
          textColor: 'primary'
        }}
        onTabChange={this.trackSwipe}
      >
        <SwipeableTab
          id="dashboardLeft"
          tabProps={{
            className: 'smalldots__dots'
          }}
          containerProps={{
            style: {padding: 10}
          }}
        >
          {this.renderGaugeDashboard()}
        </SwipeableTab>

        <SwipeableTab
          id="dashboardRight"
          tabProps={{
            className: 'smalldots__dots'
          }}
          containerProps={{
            style: {padding: 10}
          }}
        >
          {this.renderOerEventsDashboard()}
        </SwipeableTab>
      </SwipeableTabs>
    );
  }

  renderWihoutTabs() {
    if (this.props.withTabs) {
      return null;
    }

    return (
      <div className="playerdashboard-content">
        <div className="playerdashboard-content__gauges">
          {this.renderGaugeDashboard()}
        </div>

        <div className="playerdashboard-content__oer-events">
          {this.renderOerEventsDashboard()}
        </div>
      </div>
    );
  }

  render() {
    return (
      <div
        className={classnames({
          dashboard: true,
          'dashboard-closed dashboard-after': !this.props.mediaLoaded
        })}
        style={{width: '100%'}}
      >
        {this.renderWithTabs()}
        {this.renderWihoutTabs()}
      </div>
    );
  }

}
